import * as videoExperiment from '../experiments/video';
import WithExperiment from './WithExperiment';

type ExperimentLoaderProps = {
  children: React.ReactElement;
};

const ExperimentLoader = ({ children }: ExperimentLoaderProps) => (
  <>
    <WithExperiment {...videoExperiment} />
    {children}
  </>
);

export default ExperimentLoader;